import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouseSwitch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_903_20353",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_903_20353)",
		children: /* @__PURE__ */ _jsx("path", { d: "M3.19238 19.4998V10.2114L8.69233 4.71143L14.1923 10.2114V19.4998H3.19238ZM4.69233 17.9998H7.80773L9.5 18L8 17.9998H9.57696H12.6923V10.8248L8.69233 6.82483L4.69233 10.8248V17.9998ZM16 19.5094V9.4633L11.2481 4.71143H13.3711L17.5 8.84025V19.5094H16ZM19.3076 19.5094V8.09218L15.9269 4.71143H18.0595L20.8076 7.4691V19.5094H19.3076Z" })
	})]
});
export default SvgHouseSwitch;
